import { StorageService } from "../../services/StorageService";
import * as types from "./jobPostingActionTypes";

const stateObject = {
  isLoading: false,
  isSuccess: false,
  payload: [],
  error: null,
  isError: false
};

const initialState = {
  metaData: {
    ...stateObject,
    payload: {
      categories: { options: [] },
      english_level: { options: [] },
      gender: { options: [] },
      job_type: { options: [] },
      minimum_qualification: { options: [] },
      perks: { options: [] },
      working_days: { options: [] },
      job_fee_deposit_reasons: { options: [] },
      job_fee_deposit_time: { options: [] },
      job_type_location: { options: [] }
    }
  },
  keywords: { ...stateObject },
  city: { ...stateObject },
  localities: { ...stateObject },
  qualification: { ...stateObject },
  skills: { ...stateObject },
  uploadFile: { ...stateObject },
  postedJob: { ...stateObject },
  editProfile: { ...stateObject },
  jobData: { ...stateObject },
  jobsHomeList: { ...stateObject },
  jobPreviewData: { ...stateObject },
  searchJobTitle: { ...stateObject, payload: { job_titles: {} } },
  suggestedJD: { ...stateObject },
  editedJobField: { ...stateObject },
  sendEmailState: { ...stateObject },
  addClientState: { ...stateObject },
  updateClientState: { ...stateObject },
  organisationsState: { ...stateObject },
  contextualFormFields: {
    ...stateObject,
    job_post_fields: {
      ctx_title: { visible: true },
      ctx_categories: { visible: true },
      ctx_no_of_openings: { visible: true },
      ctx_minimum_salary: { visible: false },
      ctx_maximum_salary: { visible: false },
      ctx_city: { visible: true },
      ctx_locality: { visible: true },
      ctx_walkin_interview: { visible: false },
      ctx_gender: { visible: true, options: ["Any", "Male", "Female"] },
      ctx_company_perks_text: { visible: false },
      ctx_suggested_job_description: { visible: false },
      ctx_other_job_details: { visible: false },
      ctx_job_type: {
        visible: true,
        options: ["Full Time", "Part Time", "Both"]
      },
      ctx_work_location: { visible: true },
      ctx_job_timings: { visible: false },
      ctx_working_days: {
        visible: false,
        options: ["5 days working", "6 days working", "Others"]
      },
      ctx_shift_type: { visible: false },
      ctx_skills: { visible: false },
      ctx_plus_incentives: { visible: false },
      ctx_minimum_qualification: {
        visible: false,
        options: [
          "Any",
          "10th Pass",
          "12th Pass",
          "Diploma",
          "Graduate",
          "Post Graduate"
        ],
        median_value: ""
      },
      ctx_company_perks: { visible: false },
      ctx_assets: { visible: false },
      ctx_english_fluency: { visible: false },
      ctx_additional_fee_applicable: { visible: false },
      ctx_prior_experience: { visible: false },
      ctx_delivery_types: { visible: false },
      ctx_target_based: { visible: false },
      ctx_per_packet: { visible: false },
      ctx_sales_type: { visible: false },
      ctx_regional_languages: { visible: false },
      ctx_allow_lower_education: { visible: false },
      ctx_work_from_home: { visible: false },
      ctx_prior_experience_type: { visible: false },
      ctx_experience: { visible: true, median_value: "" },
      ctx_enhanced_job_description: { visible: false }
    }
  },
  isPostJob: false,
  isSaveJobClicked: false,
  isSaveManually: false,
  error: null,
  isError: false,
  isFirstJob: false,
  changePhoneSendState: { ...stateObject, payload: {} },
  changePhoneVerifyState: { ...stateObject, payload: {} },
  liveJobConfigState: {
    ...stateObject,
    payload: { show_reco_before_document: false }
  },
  metaDataVersion: {
    ...stateObject,
    payload: {}
  },
  avgSalaryState: { ...stateObject, payload: { average_salary: "" } },
  famousLocations: {
    ...stateObject,
    payload: []
  }
};

export default function jobPostingReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_JOB_POST_DATA_LOADING:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: true
        }
      };
    case types.GET_JOB_POST_DATA_SUCCESS:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_JOB_POST_DATA_FAILURE:
      return {
        ...state,
        metaData: {
          ...state.metaData,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.GET_CITY_LOADING:
      return {
        ...state,
        city: {
          ...state.city,
          isLoading: true
        }
      };
    case types.GET_CITY_SUCCESS:
      return {
        ...state,
        city: {
          ...state.city,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload.options,
          version: action.payload.version
        }
      };
    case types.GET_CITY_FAILURE:
      return {
        ...state,
        city: {
          ...state.city,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.GET_LOCALITY_LOADING:
      return {
        ...state,
        localities: {
          ...state.localities,
          isLoading: true
        }
      };
    case types.GET_LOCALITY_SUCCESS:
      return {
        ...state,
        localities: {
          ...state.localities,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_LOCALITY_FAILURE:
      return {
        ...state,
        localities: {
          ...state.localities,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.UPLOAD_FILE_LOADING:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          isLoading: true
        }
      };
    case types.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.UPLOAD_FILE_FAILURE:
      return {
        ...state,
        uploadFile: {
          ...state.uploadFile,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.CLEAR_POST_JOB:
      return {
        ...state,
        postedJob: {
          isLoading: false,
          isSuccess: false,
          payload: [],
          error: null,
          isError: false
        }
      };
    case types.POST_JOB_LOADING:
      return {
        ...state,
        postedJob: {
          ...state.postedJob,
          isLoading: true
        }
      };
    case types.POST_JOB_SUCCESS:
      return {
        ...state,
        postedJob: {
          ...state.postedJob,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload,
          isDraft: action.isDraft
        }
      };
    case types.POST_JOB_FAILURE:
      return {
        ...state,
        postedJob: {
          ...state.postedJob,
          isLoading: false,
          isSuccess: false,
          error: action.payload.errorMessage,
          details: action.payload.details,
          isError: true
        },
        isError: true
      };

    case types.EDIT_PROFILE_LOADING:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          isLoading: true
        }
      };
    case types.EDIT_PROFILE_SUCCESS:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.EDIT_PROFILE_FAILURE:
      return {
        ...state,
        editProfile: {
          ...state.editProfile,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.CLEAR_JOB_DATA: {
      const clearState = {
        ...initialState,
        city: state.city,
        metaDataVersion: state.metaDataVersion
      };
      const reset = JSON.parse(JSON.stringify(clearState));
      return reset;
    }
    case types.GET_JOB_LOADING:
      return {
        ...state,
        jobData: {
          ...state.jobData,
          isLoading: true
        }
      };
    case types.GET_JOB_SUCCESS:
      return {
        ...state,
        jobData: {
          ...state.jobData,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_JOB_FAILURE:
      return {
        ...state,
        jobData: {
          ...state.jobData,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.GET_JOBS_HOME_LOADING:
      return {
        ...state,
        jobsHomeList: {
          ...state.jobsHomeList,
          isLoading: true
        }
      };
    case types.GET_JOBS_HOME_SUCCESS:
      return {
        ...state,
        jobsHomeList: {
          ...state.jobsHomeList,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_JOBS_HOME_SUCCESS:
      return {
        ...state,
        jobsHomeList: {
          ...state.jobsHomeList,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.POST_JOB_CLICKED:
      return {
        ...state,
        isPostJob: action.payload
      };

    case types.SAVE_JOB_CLICKED:
      return {
        ...state,
        isSaveJobClicked: action.payload
      };
    case types.SAVE_MANUALLY_CLICKED:
      return {
        ...state,
        isSaveManually: action.payload
      };
    case types.GET_JOBTITLE_LOADING:
      return {
        ...state,
        searchJobTitle: {
          ...state.searchJobTitle,
          isLoading: true
        }
      };
    case types.GET_JOBTITLE_SUCCESS:
      return {
        ...state,
        searchJobTitle: {
          ...state.searchJobTitle,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_JOBTITLE_FAILURE:
      return {
        ...state,
        searchJobTitle: {
          ...state.searchJobTitle,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.GET_JD_LOADING:
      return {
        ...state,
        suggestedJD: {
          ...state.suggestedJD,
          isLoading: true
        }
      };
    case types.GET_JD_SUCCESS:
      return {
        ...state,
        suggestedJD: {
          ...state.suggestedJD,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_JD_FAILURE:
      return {
        ...state,
        suggestedJD: {
          ...state.suggestedJD,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };
    case types.GET_EDITED_JOB_FIELD_LOADING:
      return {
        ...state,
        editedJobField: {
          ...state.editedJobField,
          isLoading: true
        }
      };
    case types.GET_EDITED_JOB_FIELD_SUCCESS:
      return {
        ...state,
        editedJobField: {
          ...state.editedJobField,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_EDITED_JOB_FIELD_FAILURE:
      return {
        ...state,
        editedJobField: {
          ...state.editedJobField,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.GET_FORM_FIELDS_LOADING:
      return {
        ...state,
        contextualFormFields: {
          ...state.contextualFormFields,
          isLoading: true
        }
      };
    case types.GET_FORM_FIELDS_SUCCESS:
      return {
        ...state,
        contextualFormFields: {
          ...state.contextualFormFields,
          isLoading: false,
          isSuccess: true,
          error: null,
          job_post_fields: {
            ...state.contextualFormFields.job_post_fields,
            ctx_title: action.payload.title,
            ctx_categories: action.payload.categories,
            ctx_no_of_openings: action.payload.no_of_openings,
            ctx_minimum_salary: action.payload.minimum_salary,
            ctx_maximum_salary: action.payload.maximum_salary,
            ctx_city: action.payload.city,
            ctx_locality: action.payload.locality,
            ctx_walkin_interview: action.payload.walkin_interview,
            ctx_gender: action.payload.gender,
            ctx_company_perks_text: action.payload.company_perks_text,
            ctx_suggested_job_description:
              action.payload.suggested_job_description,
            ctx_enhanced_job_description:
              action.payload.enhanced_job_description,
            ctx_other_job_details: action.payload.other_job_details,
            ctx_job_type: action.payload.job_type,
            ctx_job_timings: action.payload.job_timings,
            ctx_working_days: action.payload.working_days,
            ctx_shift_type: action.payload.shift_type,
            ctx_skills: action.payload.skills,
            ctx_plus_incentives: action.payload.plus_incentives,
            ctx_minimum_qualification: action.payload.minimum_qualification,
            ctx_company_perks: action.payload.company_perks,
            ctx_assets: action.payload.assets_v2,
            ctx_english_fluency:
              action.payload.english_fluency_job_posting_form,
            ctx_additional_fee_applicable:
              action.payload.is_additional_fee_applicable,
            ctx_prior_experience: action.payload.prior_experience,
            ctx_delivery_types: action.payload.delivery_types
              ? action.payload.delivery_types
              : state.contextualFormFields.job_post_fields.ctx_delivery_types,
            ctx_target_based: action.payload.is_target_based
              ? action.payload.is_target_based
              : state.contextualFormFields.job_post_fields.ctx_target_based,
            ctx_per_packet: action.payload.is_per_packet_based
              ? action.payload.is_per_packet_based
              : state.contextualFormFields.job_post_fields.ctx_per_packet,
            ctx_sales_type: action.payload.sales_type
              ? action.payload.sales_type
              : state.contextualFormFields.job_post_fields.ctx_sales_type,
            ctx_regional_languages: action.payload.regional_languages
              ? action.payload.regional_languages
              : state.contextualFormFields.job_post_fields
                  .ctx_regional_languages,
            ctx_allow_lower_education: action.payload.allow_lower_education
              ? action.payload.allow_lower_education
              : state.contextualFormFields.job_post_fields
                  .ctx_regional_languages,
            ctx_work_from_home: action.payload.is_wfh
              ? action.payload.is_wfh
              : state.contextualFormFields.job_post_fields.ctx_work_from_home,
            ctx_prior_experience_type: action.payload.prior_experience_type
              ? action.payload.prior_experience_type
              : state.contextualFormFields.job_post_fields
                  .ctx_prior_experience_type,
            ctx_experience: action.payload.experience
              ? action.payload.experience
              : state.contextualFormFields.job_post_fields.ctx_experience
          }
        }
      };
    case types.GET_FORM_FIELDS_FAILURE:
      return {
        ...state,
        contextualFormFields: {
          ...state.contextualFormFields,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.SEND_VERIFICATION_EMAIL_LOADING:
      return {
        ...state,
        sendEmailState: {
          ...state.sendEmailState,
          isLoading: true
        }
      };
    case types.SEND_VERIFICATION_EMAIL_SUCCESS:
      return {
        ...state,
        sendEmailState: {
          ...state.sendEmailState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.SEND_VERIFICATION_EMAIL_FAILURE:
      return {
        ...state,
        sendEmailState: {
          ...state.sendEmailState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.ADD_CLIENT_LOADING:
      return {
        ...state,
        addClientState: {
          ...state.addClientState,
          isLoading: true
        }
      };
    case types.ADD_CLIENT_SUCCESS:
      return {
        ...state,
        addClientState: {
          ...state.addClientState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.ADD_CLIENT_FAILURE:
      return {
        ...state,
        addClientState: {
          ...state.addClientState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.UPDATE_CLIENT_LOADING:
      return {
        ...state,
        updateClientState: {
          ...state.updateClientState,
          isLoading: true
        }
      };
    case types.UPDATE_CLIENT_SUCCESS:
      return {
        ...state,
        updateClientState: {
          ...state.updateClientState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.UPDATE_CLIENT_FAILURE:
      return {
        ...state,
        updateClientState: {
          ...state.updateClientState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        },
        isError: true
      };

    case types.IS_FIRST_JOB:
      return {
        ...state,
        isFirstJob: action.payload
      };

    case types.CHANGE_PHONE_SEND_OTP_LOADING:
      return {
        ...state,
        changePhoneSendState: {
          ...state.changePhoneSendState,
          isLoading: true
        }
      };
    case types.CHANGE_PHONE_SEND_OTP_SUCCESS:
      return {
        ...state,
        changePhoneSendState: {
          ...state.changePhoneSendState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.CHANGE_PHONE_SEND_OTP_FAILURE:
      return {
        ...state,
        changePhoneSendState: {
          ...state.changePhoneSendState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.CHANGE_PHONE_VERIFY_OTP_LOADING:
      return {
        ...state,
        changePhoneVerifyState: {
          ...state.changePhoneVerifyState,
          isLoading: true
        }
      };
    case types.CHANGE_PHONE_VERIFY_OTP_SUCCESS:
      return {
        ...state,
        changePhoneVerifyState: {
          ...state.changePhoneVerifyState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.CHANGE_PHONE_VERIFY_OTP_FAILURE:
      return {
        ...state,
        changePhoneVerifyState: {
          ...state.changePhoneVerifyState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_ORGANISATIONS_LOADING:
      return {
        ...state,
        organisationsState: {
          ...state.organisationsState,
          isLoading: true
        }
      };
    case types.GET_ORGANISATIONS_SUCCESS:
      return {
        ...state,
        organisationsState: {
          ...state.organisationsState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    case types.GET_ORGANISATIONS_FAILURE:
      return {
        ...state,
        organisationsState: {
          ...state.organisationsState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };

    case types.GET_META_DATA_VER_SUCCESS:
      return {
        ...state,
        metaDataVersion: {
          ...state.metaDataVersion,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload,
          sessionId: StorageService.getSessionId()
        }
      };

    case types.GET_AVG_SALARY_LOADING:
      return {
        ...state,
        avgSalaryState: {
          ...state.avgSalaryState,
          isLoading: true
        }
      };
    case types.GET_AVG_SALARY_SUCCESS:
      return {
        ...state,
        avgSalaryState: {
          ...state.avgSalaryState,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: { average_salary: action.payload }
        }
      };
    case types.GET_AVG_SALARY_FAILURE:
      return {
        ...state,
        avgSalaryState: {
          ...state.avgSalaryState,
          isLoading: false,
          isSuccess: false,
          error: action.payload,
          isError: true
        }
      };
    case types.FAMOUS_LOCATION_METADATA_SUCCESS:
      return {
        ...state,
        famousLocations: {
          ...state.famousLocations,
          isLoading: false,
          isSuccess: true,
          error: null,
          payload: action.payload
        }
      };
    default:
      return state;
  }
}
